/* MABEL theme — HoneyBloomPixels */
(function () {
  'use strict';

  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));
  const routes = window.routes || {};

  /* ---------- Announcement bar ---------- */
  function initAnnouncements() {
    $$('[data-announcement]').forEach((bar) => {
      const items = $$('.announcement__item', bar);
      if (items.length < 2) return;
      let i = 0;
      const show = (n) => {
        items[i].classList.remove('is-active');
        i = (n + items.length) % items.length;
        items[i].classList.add('is-active');
      };
      $('[data-prev]', bar)?.addEventListener('click', () => show(i - 1));
      $('[data-next]', bar)?.addEventListener('click', () => show(i + 1));
      const speed = parseInt(bar.dataset.speed || '5', 10) * 1000;
      let timer = setInterval(() => show(i + 1), speed);
      bar.addEventListener('mouseenter', () => clearInterval(timer));
      bar.addEventListener('mouseleave', () => { timer = setInterval(() => show(i + 1), speed); });
    });
  }

  /* ---------- Generic open/close panels ---------- */
  function openPanel(el) {
    if (!el) return;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    const focusable = el.querySelector('input, button, a');
    if (focusable) setTimeout(() => focusable.focus(), 50);
  }
  function closePanel(el) {
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  function initPanels() {
    document.addEventListener('click', (e) => {
      const opener = e.target.closest('[data-open]');
      if (opener) {
        const target = document.getElementById(opener.dataset.open);
        if (target) {
          e.preventDefault();
          openPanel(target);
        }
      }
      const closer = e.target.closest('[data-close]');
      if (closer) {
        e.preventDefault();
        closePanel(closer.closest('.is-open'));
      }
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') $$('.mobile-menu.is-open, .search-modal.is-open, .cart-drawer.is-open').forEach(closePanel);
    });
  }

  /* ---------- Cart ---------- */
  function formatMoney(cents) {
    const fmt = (window.mabel && window.mabel.moneyFormat) || '${{amount}}';
    const value = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, value);
  }

  function updateCartCount(count) {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  async function refreshDrawer(open) {
    const drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    try {
      const res = await fetch(`${routes.root_url === '/' ? '' : routes.root_url}/?sections=cart-drawer`);
      const data = await res.json();
      const html = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
      const fresh = html.getElementById('CartDrawer');
      if (fresh) drawer.innerHTML = fresh.innerHTML;
      safe(initFreeShipping);
      const count = drawer.querySelector('[data-drawer-count]');
      if (count) updateCartCount(parseInt(count.dataset.drawerCount, 10));
      if (open) openPanel(drawer);
    } catch (err) {
      window.location.href = routes.cart_url;
    }
  }

  function initCart() {
    document.addEventListener('submit', async (e) => {
      const form = e.target.closest('form[action*="/cart/add"]');
      if (!form || !window.mabel || window.mabel.cartType !== 'drawer' || !document.getElementById('CartDrawer')) return;
      e.preventDefault();
      const button = form.querySelector('[type="submit"]');
      const error = form.querySelector('[data-form-error]');
      if (button) button.classList.add('is-loading');
      if (error) error.hidden = true;
      try {
        const res = await fetch(`${routes.cart_add_url}.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });
        const data = await res.json();
        if (data.status && data.status !== 200) {
          if (error) {
            error.textContent = data.description || data.message;
            error.hidden = false;
          }
        } else {
          const qv = form.closest('[data-quick-view-dialog]');
          if (qv && qv.open) qv.close();
          await refreshDrawer(true);
        }
      } catch (err) {
        form.submit();
      } finally {
        if (button) button.classList.remove('is-loading');
      }
    });

    document.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-cart-change]');
      if (!btn) return;
      e.preventDefault();
      const key = btn.dataset.key;
      let qty = parseInt(btn.dataset.cartChange, 10);
      const scope = btn.closest('[data-cart-scope]');
      if (scope) scope.classList.add('is-loading');
      try {
        await fetch(`${routes.cart_change_url}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity: Math.max(0, qty) })
        });
        if (btn.closest('#CartDrawer')) {
          await refreshDrawer(false);
        } else {
          window.location.reload();
        }
      } finally {
        if (scope) scope.classList.remove('is-loading');
      }
    });
  }

  /* ---------- Quantity inputs ---------- */
  function initQty() {
    document.addEventListener('click', (e) => {
      const b = e.target.closest('[data-qty]');
      if (!b) return;
      const input = b.parentElement.querySelector('input');
      if (!input) return;
      const step = b.dataset.qty === 'plus' ? 1 : -1;
      const min = parseInt(input.min || '1', 10);
      input.value = Math.max(min, (parseInt(input.value, 10) || min) + step);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* ---------- Product page ---------- */
  function initProducts() {
    $$('[data-product]').forEach((root) => {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      const json = $('[data-product-json]', root);
      if (!json) return;
      const product = JSON.parse(json.textContent);
      if (!product || !Array.isArray(product.variants)) return;
      let inventory = {};
      try { inventory = JSON.parse(($('[data-inventory]', root) || {}).textContent || '{}'); } catch (e) {}
      const form = $('form[action*="/cart/add"]', root);
      const idInput = form ? form.querySelector('[name="id"]') : null;
      const priceEls = $$('[data-price]', root);
      const compareEls = $$('[data-compare]', root);
      const addBtns = $$('[data-add-button]', root);
      const floatAdd = $('[data-float-add]', root);
      const mainImg = $('[data-main-image]', root);
      const slides = $('[data-slides]', root);
      const dots = $$('[data-dot]', root);
      const stock = $('[data-low-stock]', root);
      const stockBar = $('[data-stock-bar]', root);
      const notify = $('[data-notify]', root);
      const notifyBody = $('[data-notify-body]', root);
      const preNote = $('[data-preorder-note]', root);
      let preorder = {};
      try { const pj = $('[data-preorder]', root); if (pj) preorder = JSON.parse(pj.textContent); } catch (e) { preorder = {}; }
      const plans = $('[data-plans]', root);
      const planInput = plans ? $('[data-selling-plan]', plans) : null;
      let currentVariant = product.variants.find((v) => idInput && String(v.id) === idInput.value) || product.variants[0];

      const applyPlan = () => {
        if (!plans) return;
        const checked = plans.querySelector('input[type="radio"]:checked');
        const planId = checked ? checked.value : '';
        if (planInput) planInput.value = planId;
        let price = currentVariant.price;
        if (planId) {
          const alloc = (currentVariant.selling_plan_allocations || []).find((a) => String(a.selling_plan_id) === planId);
          if (alloc) price = alloc.price;
        }
        priceEls.forEach((el) => { el.textContent = formatMoney(price); });
        $$('.plan', plans).forEach((label) => {
          const input = label.querySelector('input');
          const out = label.querySelector('.plan__price');
          if (!out) return;
          if (!input.value) { out.textContent = formatMoney(currentVariant.price); return; }
          const a = (currentVariant.selling_plan_allocations || []).find((x) => String(x.selling_plan_id) === input.value);
          if (a) out.textContent = formatMoney(a.price);
        });
      };
      if (plans) $$('input[type="radio"]', plans).forEach((i) => i.addEventListener('change', applyPlan));

      const setLabel = (btn, text) => { const sp = btn.querySelector('span'); if (sp) sp.textContent = text; };

      const updateStock = (variant) => {
        if (!stock) return;
        const limit = parseInt(stock.dataset.lowStock, 10);
        const qty = inventory[variant.id];
        const show = variant.available && typeof qty === 'number' && qty > 0 && qty <= limit;
        stock.hidden = !show;
        if (show) $('[data-stock-text]', stock).textContent = stock.dataset.template.replace('__QTY__', qty);
        if (stockBar) {
          stockBar.hidden = !show;
          if (show) $('i', stockBar).style.width = Math.max(6, Math.min(100, Math.round(qty / limit * 100))) + '%';
        }
      };

      const goToSlide = (i, smooth = true) => {
        if (!slides) return;
        slides.scrollTo({ left: slides.clientWidth * i, behavior: smooth ? 'smooth' : 'auto' });
      };

      const onChange = () => {
        const selected = $$('fieldset.option', root).map((fs) => {
          const checked = fs.querySelector('input:checked');
          return checked ? checked.value : null;
        });
        const variant = product.variants.find((v) => v.options.every((o, i) => o === selected[i]));
        $$('fieldset.option', root).forEach((fs) => {
          const out = fs.querySelector('[data-option-value]');
          const c = fs.querySelector('input:checked');
          if (out && c) out.textContent = c.value;
        });
        if (!variant) {
          addBtns.forEach((btn) => { btn.disabled = true; setLabel(btn, btn.dataset.unavailable); });
          if (floatAdd) floatAdd.disabled = true;
          if (stock) stock.hidden = true;
          return;
        }
        currentVariant = variant;
        if (idInput) idInput.value = variant.id;
        priceEls.forEach((el) => { el.textContent = formatMoney(variant.price); });
        applyPlan();
        compareEls.forEach((el) => { el.textContent = variant.compare_at_price > variant.price ? formatMoney(variant.compare_at_price) : ''; });
        const isPre = !!preorder[variant.id];
        addBtns.forEach((btn) => {
          btn.disabled = !variant.available;
          setLabel(btn, variant.available ? (isPre && btn.dataset.preorderLabel ? btn.dataset.preorderLabel : btn.dataset.add) : btn.dataset.soldout);
        });
        if (preNote) preNote.hidden = !isPre;
        if (notify) notify.hidden = variant.available;
        if (notifyBody) notifyBody.value = notifyBody.value.replace(/: .*$/, ': ' + (notifyBody.dataset.productTitle || '') + ' – ' + variant.title + ' (' + variant.id + ')');
        if (floatAdd) floatAdd.disabled = !variant.available;
        updateStock(variant);
        if (variant.featured_media) {
          if (mainImg && variant.featured_image) {
            mainImg.src = variant.featured_image.src;
            mainImg.removeAttribute('srcset');
          }
          if (slides) {
            const idx = $$('[data-media-id]', slides).findIndex((s) => s.dataset.mediaId === String(variant.featured_media.id));
            if (idx > -1) goToSlide(idx);
          }
        }
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        root.dispatchEvent(new CustomEvent('mabel:variant', { bubbles: true, detail: { variant } }));
        window.history.replaceState({}, '', url.toString());
      };
      $$('fieldset.option input', root).forEach((i) => i.addEventListener('change', onChange));

      $$('[data-thumb]', root).forEach((t) => {
        t.addEventListener('click', () => {
          $$('[data-thumb]', root).forEach((x) => x.classList.remove('is-active'));
          t.classList.add('is-active');
          if (slides && t.dataset.index) { goToSlide(parseInt(t.dataset.index, 10)); return; }
          if (mainImg) {
            mainImg.src = t.dataset.src;
            mainImg.removeAttribute('srcset');
            mainImg.alt = t.dataset.alt || '';
          }
        });
      });

      if (slides && dots.length) {
        let ticking = false;
        slides.addEventListener('scroll', () => {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(() => {
            const i = Math.round(slides.scrollLeft / Math.max(1, slides.clientWidth));
            dots.forEach((d, n) => d.classList.toggle('is-active', n === i));
            $$('[data-thumb]', root).forEach((t) => t.classList.toggle('is-active', t.dataset.index === String(i)));
            slides.dataset.index = i;
            ticking = false;
          });
        }, { passive: true });
        dots.forEach((d) => d.addEventListener('click', () => goToSlide(parseInt(d.dataset.dot, 10))));
        const step = (dir) => {
          const cur = parseInt(slides.dataset.index || '0', 10);
          goToSlide((cur + dir + dots.length) % dots.length);
        };
        $('[data-slide-prev]', root)?.addEventListener('click', () => step(-1));
        $('[data-slide-next]', root)?.addEventListener('click', () => step(1));
      }

      const zoom = $('[data-zoom-dialog]', root);
      if (zoom && typeof zoom.showModal === 'function') {
        const zImg = $('[data-zoom-img]', zoom);
        const stage = $('[data-zoom-stage]', zoom);
        const open = (src) => {
          if (!src) return;
          zImg.src = src;
          zoom.classList.remove('is-zoomed');
          zoom.showModal();
          document.documentElement.classList.add('no-scroll');
        };
        const close = () => { zoom.close(); };
        zoom.addEventListener('close', () => document.documentElement.classList.remove('no-scroll'));
        $('[data-zoom-close]', zoom).addEventListener('click', close);
        zoom.addEventListener('click', (e) => { if (e.target === zoom) close(); });
        $$('[data-zoom]', root).forEach((sl) => {
          sl.style.cursor = 'zoom-in';
          sl.addEventListener('click', () => open(sl.dataset.zoom));
        });
        if (mainImg && !slides) {
          mainImg.style.cursor = 'zoom-in';
          mainImg.addEventListener('click', () => open(mainImg.currentSrc || mainImg.src));
        }
        stage.addEventListener('click', () => zoom.classList.toggle('is-zoomed'));
        stage.addEventListener('mousemove', (e) => {
          const r = stage.getBoundingClientRect();
          zImg.style.transformOrigin = `${((e.clientX - r.left) / r.width) * 100}% ${((e.clientY - r.top) / r.height) * 100}%`;
        });
      }

      const sticky = $('[data-sticky-atc]', root);
      const buyBox = $('[data-buy-box]', root);
      if (sticky && buyBox && 'IntersectionObserver' in window) {
        new IntersectionObserver(([entry]) => {
          const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', show);
          document.documentElement.classList.toggle('has-sticky-atc', show);
          sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
          sticky.querySelectorAll('button, a').forEach((b) => { b.tabIndex = show ? 0 : -1; });
        }).observe(buyBox);
      }
    });
  }

  /* ---------- Video popup ---------- */
  function initVideo() {
    if (window.__mabelVideo) return;
    window.__mabelVideo = true;
    document.addEventListener('click', (e) => {
      const open = e.target.closest('[data-video-open]');
      const dialog = document.querySelector('[data-video-dialog]');
      if (!dialog) return;
      const frame = $('[data-video-frame]', dialog);
      if (open) {
        frame.innerHTML = `<iframe src="${open.dataset.videoOpen}" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen title="Video"></iframe>`;
        if (dialog.showModal) dialog.showModal(); else dialog.setAttribute('open', '');
      } else if (e.target.closest('[data-video-close]') || e.target === dialog) {
        dialog.close ? dialog.close() : dialog.removeAttribute('open');
      }
    });
    document.addEventListener('close', (e) => {
      if (e.target.matches && e.target.matches('[data-video-dialog]')) $('[data-video-frame]', e.target).innerHTML = '';
    }, true);
  }

  /* ---------- Video reviews ---------- */
  function initVideoReviews() {
    if (window.__mabelVR) return;
    window.__mabelVR = true;
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-vreview-sound]');
      if (!btn) return;
      const card = btn.closest('[data-vreview]');
      const video = card && card.querySelector('video');
      if (!video) return;
      const turnOn = video.muted;
      $$('[data-vreview] video').forEach((v) => { v.muted = true; });
      $$('[data-vreview-sound]').forEach((b) => {
        b.setAttribute('aria-pressed', 'false');
        b.querySelector('[data-icon-muted]').hidden = false;
        b.querySelector('[data-icon-sound]').hidden = true;
      });
      if (turnOn) {
        video.muted = false;
        video.play();
        btn.setAttribute('aria-pressed', 'true');
        btn.querySelector('[data-icon-muted]').hidden = true;
        btn.querySelector('[data-icon-sound]').hidden = false;
      }
    });
  }

  /* ---------- Before / after slider ---------- */
  function initBeforeAfter() {
    $$('[data-ba]').forEach((el) => {
      const range = $('[data-ba-range]', el);
      if (!range || range.dataset.ready) return;
      range.dataset.ready = '1';
      range.addEventListener('input', () => el.style.setProperty('--pos', `${range.value}%`));
    });
  }

  /* ---------- FAQ shortcut ---------- */
  function initFaqLinks() {
    if (window.__mabelFaq) return;
    window.__mabelFaq = true;
    document.addEventListener('click', (e) => {
      const link = e.target.closest('[data-faq-link]');
      if (!link) return;
      const target = document.querySelector(link.getAttribute('href'));
      if (!target) return;
      e.preventDefault();
      if (target.tagName === 'DETAILS') target.open = true;
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  /* ---------- Hover collection list ---------- */
  function initHoverLists() {
    $$('[data-hover-list]').forEach((root) => {
      const links = $$('[data-hover-index]', root);
      const media = $$('[data-media-index]', root);
      const activate = (idx) => {
        links.forEach((l) => l.classList.toggle('is-active', l.dataset.hoverIndex === idx));
        media.forEach((m) => m.classList.toggle('is-active', m.dataset.mediaIndex === idx));
      };
      links.forEach((l) => {
        l.addEventListener('mouseenter', () => activate(l.dataset.hoverIndex));
        l.addEventListener('focus', () => activate(l.dataset.hoverIndex));
      });
    });
  }

  /* ---------- Collection filters ---------- */
  function initFilters() {
    if (window.__mabelFilters) return;
    window.__mabelFilters = true;
    if (window.matchMedia('(max-width: 749px)').matches) {
      $$('[data-filter-form] ~ * details[open], .filters details[open], .collection-layout details[open]').forEach((d) => d.removeAttribute('open'));
    }
    document.addEventListener('change', (e) => {
      const form = e.target.form;
      if (!form || !form.matches('[data-filter-form]')) return;
      const params = new URLSearchParams(new FormData(form));
      for (const [k, v] of Array.from(params.entries())) if (v === '') params.delete(k);
      window.location.search = params.toString();
    });
  }

  /* ---------- Scroll reveal ---------- */
  function initReveal() {
    document.documentElement.classList.add('js-reveal');
    const els = $$('[data-reveal]');
    if (!('IntersectionObserver' in window)) {
      els.forEach((el) => el.classList.add('is-visible'));
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (en.isIntersecting) {
          en.target.classList.add('is-visible');
          io.unobserve(en.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    els.forEach((el) => io.observe(el));
  }

  /* ---------- Product recommendations ---------- */
  function initRecommendations() {
    $$('[data-recommendations]').forEach((el) => {
      if (el.dataset.loaded) return;
      el.dataset.loaded = '1';
      fetch(el.dataset.url)
        .then((r) => r.text())
        .then((html) => {
          const tmp = document.createElement('div');
          tmp.innerHTML = html;
          const fresh = tmp.querySelector('[data-recommendations]');
          if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
        })
        .catch(() => {});
    });
  }

  /* ---------- Back to top ---------- */
  function initBackToTop() {
    const btn = document.querySelector('[data-back-to-top]');
    if (!btn || btn.dataset.ready) return;
    btn.dataset.ready = '1';
    btn.hidden = false;
    let ticking = false;
    const update = () => {
      const show = window.scrollY > window.innerHeight * 0.8;
      btn.classList.toggle('is-visible', show);
      btn.tabIndex = show ? 0 : -1;
      ticking = false;
    };
    window.addEventListener('scroll', () => {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    update();
    btn.addEventListener('click', () => {
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
      const target = document.getElementById('MainContent') || document.body;
      target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
    });
  }

  /* ---------- Free shipping bar in the shopper's currency ---------- */
  function initFreeShipping() {
    const rate = parseFloat((window.Shopify && Shopify.currency && Shopify.currency.rate) || '1') || 1;
    $$('[data-free-ship]').forEach((el) => {
      const goal = Math.round(parseInt(el.dataset.goal, 10) * rate);
      const total = parseInt(el.dataset.total, 10) || 0;
      if (!goal) return;
      const remaining = goal - total;
      const text = el.querySelector('[data-free-ship-text]');
      const bar = el.querySelector('[data-free-ship-bar] span');
      if (text) {
        if (remaining > 0) text.textContent = el.dataset.remainingText.replace('__AMOUNT__', formatMoney(remaining));
        else text.innerHTML = '<strong>' + el.dataset.unlockedText + '</strong>';
      }
      if (bar) bar.style.width = Math.min(100, Math.round((total / goal) * 100)) + '%';
    });
  }

  function initSwatchCards() {
    if (window.__mabelSwatches) return;
    window.__mabelSwatches = true;
    const swap = (sw) => {
      const card = sw.closest('.card');
      const url = sw.dataset.swatchImg;
      if (!card || !url) return;
      const img = card.querySelector('.card__media img:not(.card__img-hover)');
      if (!img) return;
      if (!img.dataset.orig) img.dataset.orig = img.currentSrc || img.src;
      img.removeAttribute('srcset');
      img.src = url;
      $$('.swatch', sw.parentElement).forEach((x) => x.classList.toggle('is-active', x === sw));
    };
    document.addEventListener('mouseover', (e) => { const sw = e.target.closest('[data-card-swatches] .swatch'); if (sw) swap(sw); });
    document.addEventListener('focusin', (e) => { const sw = e.target.closest('[data-card-swatches] .swatch'); if (sw) swap(sw); });
  }

  function initSizeGuide() {
    if (window.__mabelSize) return;
    window.__mabelSize = true;
    document.addEventListener('click', (e) => {
      const open = e.target.closest('[data-size-guide-open]');
      if (open) {
        const root = open.closest('[data-product]') || document;
        const dlg = root.querySelector('[data-size-guide]') || document.querySelector('[data-size-guide]');
        if (dlg && dlg.showModal) { dlg.showModal(); }
        return;
      }
      const close = e.target.closest('[data-size-guide-close]');
      if (close) { const d = close.closest('dialog'); if (d) d.close(); return; }
      if (e.target.matches && e.target.matches('dialog[data-size-guide]')) e.target.close();
    });
  }

  function initLooks() {
    $$('[data-look]').forEach((look) => {
      if (look.dataset.ready) return;
      look.dataset.ready = '1';
      const dots = $$('[data-look-dot]', look);
      const items = $$('[data-look-item]', look);
      const activate = (i) => {
        dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
        items.forEach((it, k) => it.classList.toggle('is-active', k === i));
      };
      dots.forEach((d, i) => {
        d.addEventListener('click', () => { activate(i); if (items[i]) items[i].scrollIntoView({ block: 'nearest', behavior: 'smooth' }); });
        d.addEventListener('mouseenter', () => activate(i));
      });
      items.forEach((it, i) => it.addEventListener('mouseenter', () => activate(i)));
    });
  }

  function initCampaigns() {
    $$('[data-campaign]').forEach((c) => {
      if (c.dataset.ready) return;
      c.dataset.ready = '1';
      const v = c.querySelector('video');
      const btn = c.querySelector('[data-campaign-toggle]');
      if (!v || !btn) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { v.pause(); btn.dataset.state = 'paused'; }
      btn.addEventListener('click', () => {
        if (v.paused) { v.play(); btn.dataset.state = 'playing'; btn.setAttribute('aria-label', btn.dataset.pause); }
        else { v.pause(); btn.dataset.state = 'paused'; btn.setAttribute('aria-label', btn.dataset.play); }
        btn.querySelector('[data-icon-play]').hidden = !v.paused;
        btn.querySelector('[data-icon-pause]').hidden = v.paused;
      });
    });
  }


  /* ---------- MABEL 1.1: quick view ---------- */
  function initQuickView() {
    const dlg = document.querySelector('[data-quick-view-dialog]');
    if (!dlg || dlg.dataset.ready || typeof dlg.showModal !== 'function') return;
    dlg.dataset.ready = '1';
    const body = $('[data-quick-view-body]', dlg);
    const close = () => dlg.close();
    $('[data-quick-view-close]', dlg).addEventListener('click', close);
    dlg.addEventListener('click', (e) => { if (e.target === dlg) close(); });
    dlg.addEventListener('close', () => { document.documentElement.classList.remove('no-scroll'); body.innerHTML = ''; });

    const wire = () => {
      const root = $('[data-qv]', body);
      if (!root) return;
      let variants = [];
      try { variants = JSON.parse(root.dataset.qvVariants); } catch (e) { return; }
      const idInput = $('[data-qv-id]', root);
      const add = $('[data-qv-add]', root);
      const price = $('[data-qv-price]', root);
      const compare = $('[data-qv-compare]', root);
      const slides = $('[data-qv-slides]', root);
      const dots = $$('[data-qv-dot]', root);
      const go = (i) => slides && slides.scrollTo({ left: slides.clientWidth * i, behavior: 'smooth' });
      dots.forEach((d) => d.addEventListener('click', () => go(parseInt(d.dataset.qvDot, 10))));
      if (slides && dots.length) {
        slides.addEventListener('scroll', () => {
          const i = Math.round(slides.scrollLeft / Math.max(1, slides.clientWidth));
          dots.forEach((d, n) => d.classList.toggle('is-active', n === i));
        }, { passive: true });
      }
      const sets = $$('[data-qv-option]', root);
      sets.forEach((fs) => fs.addEventListener('change', () => {
        const sel = sets.map((f) => { const c = f.querySelector('input:checked'); return c ? c.value : null; });
        sets.forEach((f) => { const o = f.querySelector('[data-option-value]'); const c = f.querySelector('input:checked'); if (o && c) o.textContent = c.value; });
        const v = variants.find((x) => x.options.every((o, i) => o === sel[i]));
        const label = add.querySelector('span');
        if (!v) { add.disabled = true; label.textContent = add.dataset.unavailable; return; }
        idInput.value = v.id;
        add.disabled = !v.available;
        label.textContent = v.available ? add.dataset.add : add.dataset.soldout;
        price.textContent = formatMoney(v.price);
        compare.textContent = v.compare_at_price > v.price ? formatMoney(v.compare_at_price) : '';
        if (v.featured_media && slides) {
          const idx = $$('[data-media-id]', slides).findIndex((sl) => sl.dataset.mediaId === String(v.featured_media.id));
          if (idx > -1) go(idx);
        }
      }));
    };

    document.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-quick-view]');
      if (!btn) return;
      e.preventDefault();
      btn.classList.add('is-loading');
      try {
        const url = btn.dataset.quickView.split('?')[0];
        const res = await fetch(`${url}${url.includes('?') ? '&' : '?'}section_id=quick-view`);
        if (!res.ok) throw new Error(res.status);
        const html = await res.text();
        const tmp = document.createElement('div');
        tmp.innerHTML = html;
        const grid = tmp.querySelector('[data-qv]');
        if (!grid) throw new Error('empty');
        body.innerHTML = '';
        body.appendChild(grid);
        wire();
        dlg.showModal();
        document.documentElement.classList.add('no-scroll');
      } catch (err) {
        window.location.href = btn.dataset.quickView;
      } finally {
        btn.classList.remove('is-loading');
      }
    });
  }

  /* ---------- MABEL 1.1: recently viewed ---------- */
  function initRecentlyViewed() {
    $$('[data-recently-viewed]').forEach(async (el) => {
      if (el.dataset.ready) return;
      el.dataset.ready = '1';
      let list = [];
      try { list = JSON.parse(localStorage.getItem('mabel-recent') || '[]'); } catch (e) { list = []; }
      const current = el.dataset.current;
      list = list.filter((h) => h && h !== current).slice(0, parseInt(el.dataset.limit || '4', 10));
      const grid = $('[data-recently-grid]', el);
      if (!list.length) {
        if (!(window.Shopify && Shopify.designMode)) el.closest('.shopify-section')?.setAttribute('hidden', '');
        return;
      }
      const root = (routes.root_url || '/').replace(/\/$/, '');
      const cards = await Promise.all(list.map((h) => fetch(`${root}/products/${h}?section_id=product-card-render`).then((r) => (r.ok ? r.text() : '')).catch(() => '')));
      // Products that changed address (or redirect) can be stored twice: show each product once and keep the list tidy.
      const seen = new Set(); const clean = [];
      const html = cards.map((c) => {
        const t = document.createElement('div'); t.innerHTML = c; const card = t.querySelector('.card');
        if (!card) return '';
        const link = card.querySelector('a[href*="/products/"]');
        const handle = link ? (link.getAttribute('href').split('/products/')[1] || '').split(/[?#/]/)[0] : '';
        if (!handle || seen.has(handle) || handle === current) return '';
        seen.add(handle); clean.push(handle);
        return `<li>${card.outerHTML}</li>`;
      }).join('');
      try {
        const stored = JSON.parse(localStorage.getItem('mabel-recent') || '[]');
        const map = {}; list.forEach((h, i) => { if (cards[i]) { const t = document.createElement('div'); t.innerHTML = cards[i]; const a = t.querySelector('.card a[href*="/products/"]'); if (a) map[h] = (a.getAttribute('href').split('/products/')[1] || '').split(/[?#/]/)[0]; } });
        const tidy = []; stored.forEach((h) => { const c = map[h] || h; if (c && !tidy.includes(c)) tidy.push(c); });
        localStorage.setItem('mabel-recent', JSON.stringify(tidy));
      } catch (e) {}
      if (html) { grid.innerHTML = html; el.hidden = false; safe(initSwatchCards); }
      else el.closest('.shopify-section')?.setAttribute('hidden', '');
    });
  }

  /* ---------- MABEL 1.1: countdown ---------- */
  function initCountdowns() {
    $$('[data-countdown]').forEach((el) => {
      if (el.dataset.ready) return;
      el.dataset.ready = '1';
      const end = new Date(el.dataset.countdown).getTime();
      if (Number.isNaN(end)) return;
      const parts = { d: $('[data-cd="d"]', el), h: $('[data-cd="h"]', el), m: $('[data-cd="m"]', el), s: $('[data-cd="s"]', el) };
      const pad = (n) => String(n).padStart(2, '0');
      const tick = () => {
        let t = Math.max(0, Math.floor((end - Date.now()) / 1000));
        const d = Math.floor(t / 86400); t -= d * 86400;
        const h = Math.floor(t / 3600); t -= h * 3600;
        const m = Math.floor(t / 60); const s = t - m * 60;
        if (parts.d) parts.d.textContent = pad(d);
        if (parts.h) parts.h.textContent = pad(h);
        if (parts.m) parts.m.textContent = pad(m);
        if (parts.s) parts.s.textContent = pad(s);
        if (end - Date.now() <= 0) { el.classList.add('is-ended'); clearInterval(timer); }
      };
      const timer = setInterval(tick, 1000);
      tick();
    });
  }

  /* ---------- MABEL 1.1: promo popup ---------- */
  function initPopup() {
    const dlg = document.querySelector('[data-popup]');
    if (!dlg || dlg.dataset.ready || typeof dlg.showModal !== 'function') return;
    dlg.dataset.ready = '1';
    const key = 'mabel-popup-' + (dlg.dataset.version || '1');
    const days = parseInt(dlg.dataset.days || '7', 10);
    const close = () => {
      dlg.close();
      try { localStorage.setItem(key, String(Date.now())); } catch (e) {}
    };
    $$('[data-popup-close]', dlg).forEach((b) => b.addEventListener('click', close));
    dlg.addEventListener('click', (e) => { if (e.target === dlg) close(); });
    dlg.addEventListener('cancel', () => { try { localStorage.setItem(key, String(Date.now())); } catch (e) {} });
    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:select', (e) => { if (dlg.closest('.shopify-section')?.id === 'shopify-section-' + e.detail.sectionId) dlg.show(); });
      document.addEventListener('shopify:section:deselect', () => dlg.open && dlg.close());
      return;
    }
    if (dlg.dataset.success === 'true') { dlg.showModal(); return; }
    let last = 0;
    try { last = parseInt(localStorage.getItem(key) || '0', 10); } catch (e) {}
    if (last && Date.now() - last < days * 86400000) return;
    setTimeout(() => { if (!document.querySelector('dialog[open]')) dlg.showModal(); }, parseInt(dlg.dataset.delay || '6', 10) * 1000);
  }

  /* ---------- MABEL 1.1: slideshow ---------- */
  function initSlideshows() {
    $$('[data-slideshow]').forEach((el) => {
      if (el.dataset.ready) return;
      el.dataset.ready = '1';
      const track = $('[data-slideshow-track]', el);
      const dots = $$('[data-slideshow-dot]', el);
      const count = dots.length;
      if (!track || count < 2) return;
      let i = 0;
      const go = (n, smooth = true) => { i = (n + count) % count; track.scrollTo({ left: track.clientWidth * i, behavior: smooth ? 'smooth' : 'auto' }); };
      track.addEventListener('scroll', () => {
        i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        dots.forEach((d, n) => { d.classList.toggle('is-active', n === i); d.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      }, { passive: true });
      dots.forEach((d, n) => d.addEventListener('click', () => go(n)));
      $('[data-slideshow-prev]', el)?.addEventListener('click', () => go(i - 1));
      $('[data-slideshow-next]', el)?.addEventListener('click', () => go(i + 1));
      const speed = parseInt(el.dataset.autoplay || '0', 10) * 1000;
      if (speed && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        let timer = setInterval(() => go(i + 1), speed);
        el.addEventListener('mouseenter', () => clearInterval(timer));
        el.addEventListener('mouseleave', () => { clearInterval(timer); timer = setInterval(() => go(i + 1), speed); });
        el.addEventListener('focusin', () => clearInterval(timer));
      }
    });
  }


  /* ---------- MABEL 1.1: press quotes ---------- */
  function initPress() {
    $$('[data-press]').forEach((el) => {
      if (el.dataset.ready) return;
      el.dataset.ready = '1';
      const logos = $$('[data-press-logo]', el);
      const quotes = $$('[data-press-quote]', el);
      if (logos.length < 2) return;
      let i = 0;
      const show = (n) => {
        i = (n + logos.length) % logos.length;
        logos.forEach((l, k) => l.classList.toggle('is-active', k === i));
        quotes.forEach((q, k) => q.classList.toggle('is-active', k === i));
      };
      logos.forEach((l, k) => { l.addEventListener('click', () => show(k)); l.addEventListener('mouseenter', () => show(k)); });
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        let t = setInterval(() => show(i + 1), 5000);
        el.addEventListener('mouseenter', () => clearInterval(t));
        el.addEventListener('mouseleave', () => { clearInterval(t); t = setInterval(() => show(i + 1), 5000); });
      }
    });
  }

  /* ---------- MABEL: cart note in the drawer ---------- */
  function initCartNote() {
    let t;
    document.addEventListener('input', (e) => {
      const el = e.target.closest('[data-cart-note]');
      if (!el) return;
      clearTimeout(t);
      t = setTimeout(() => {
        fetch(`${routes.cart_update_url}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: el.value }) }).catch(() => {});
      }, 400);
    });
  }

  /* ---------- MABEL: pickup availability ---------- */
  function initPickup() {
    $$('[data-pickup]').forEach((el) => {
      if (el.dataset.ready) return;
      el.dataset.ready = '1';
      const load = async (id) => {
        if (!id) return;
        try {
          const base = routes.root_url === '/' ? '' : routes.root_url;
          const res = await fetch(`${base}/variants/${id}/?section_id=pickup-availability`);
          if (!res.ok) { el.innerHTML = ''; return; }
          const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
          const inner = doc.querySelector('.shopify-section');
          el.innerHTML = inner ? inner.innerHTML : '';
        } catch (e) { el.innerHTML = ''; }
      };
      load(el.dataset.variantId);
      const scope = el.closest('[data-product]') || document;
      scope.addEventListener('mabel:variant', (e) => load(e.detail.variant && e.detail.variant.id));
    });
  }

  function initPredictive() {
    const input = document.querySelector('[data-predictive-input]');
    const box = document.querySelector('[data-predictive-results]');
    if (!input || !box) return;
    let timer, ctrl;
    input.addEventListener('input', () => {
      clearTimeout(timer);
      const q = input.value.trim();
      if (q.length < 2) { box.innerHTML = ''; input.setAttribute('aria-expanded', 'false'); return; }
      timer = setTimeout(async () => {
        if (ctrl) ctrl.abort();
        ctrl = new AbortController();
        try {
          const base = routes.root_url === '/' ? '' : routes.root_url;
          const res = await fetch(`${base}/search/suggest?q=${encodeURIComponent(q)}&resources[type]=product,collection,page,article,query&resources[limit]=6&section_id=predictive-search`, { signal: ctrl.signal });
          const html = await res.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const inner = doc.querySelector('.shopify-section') || doc.body;
          box.innerHTML = inner.innerHTML;
          input.setAttribute('aria-expanded', 'true');
        } catch (e) {}
      }, 220);
    });
  }

  /* ---------- MABEL: product tabs ---------- */
  function initTabs() {
    $$('[data-tabs]').forEach((root) => {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      const tabs = $$('[data-tab]', root);
      const select = (tab, focus) => {
        tabs.forEach((t) => {
          const on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          const panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
        if (focus) tab.focus();
      };
      tabs.forEach((t, i) => {
        t.addEventListener('click', () => select(t));
        t.addEventListener('keydown', (e) => {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          e.preventDefault();
          const n = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
          select(n, true);
        });
      });
    });
  }

  /* ---------- MABEL: side discount tab opens the popup ---------- */
  function initSideTab() {
    const tab = document.querySelector('[data-side-tab]');
    const dlg = document.querySelector('[data-popup]');
    if (!tab) return;
    if (!dlg || typeof dlg.showModal !== 'function') { tab.hidden = true; return; }
    tab.addEventListener('click', () => { if (!dlg.open) dlg.showModal(); });
  }

  /* ---------- MABEL: floating cart button ---------- */
  function initStickyCart() {
    const btn = document.querySelector('[data-sticky-cart]');
    if (!btn) return;
    const toggle = () => btn.classList.toggle('is-visible', window.scrollY > 600);
    window.addEventListener('scroll', toggle, { passive: true });
    toggle();
    btn.addEventListener('click', (e) => {
      const drawer = document.getElementById('CartDrawer');
      if (drawer && window.mabel && window.mabel.cartType === 'drawer') { e.preventDefault(); openPanel(drawer); }
    });
  }


  function initBundleBuilder() {
    document.querySelectorAll('[data-bundle-builder]').forEach((root) => {
      if (root.dataset.bbReady) return; root.dataset.bbReady = '1';
      const S = JSON.parse(root.querySelector('[data-bb-strings]').textContent);
      const tiers = Array.from(root.querySelectorAll('[data-tier]'));
      const items = Array.from(root.querySelectorAll('[data-item]'));
      const slots = root.querySelector('[data-slots]');
      const status = root.querySelector('[data-status]');
      const total = root.querySelector('[data-total]');
      const was = root.querySelector('[data-was]');
      const add = root.querySelector('[data-add]');
      const counts = new Map(); // variantId -> { it, n, price, label }
      let size = tiers.length ? parseInt(tiers[0].dataset.tier, 10) : 6;
      let off = tiers.length ? parseInt(tiers[0].dataset.off, 10) : 0;
      const picked = () => Array.from(counts.values()).reduce((a, e) => a + e.n, 0);
      const sizeName = (it) => { const sel = it.querySelector('[data-variant]'); return sel ? sel.options[sel.selectedIndex].text : ''; };
      function render() {
        const n = picked();
        let sum = 0; const thumbs = [];
        counts.forEach((e) => { sum += e.n * e.price; for (let i = 0; i < e.n; i++) thumbs.push(e); });
        items.forEach((it) => {
          const e = counts.get(it.dataset.id);
          const c = e ? e.n : 0;
          const out = it.querySelector('[data-count]'); if (out) out.textContent = c;
          const mine = Array.from(counts.values()).filter((x) => x.it === it && x.n > 0);
          it.classList.toggle('is-picked', mine.length > 0);
          const chosen = it.querySelector('[data-chosen]');
          if (chosen) { const sel = it.querySelector('[data-variant]'); chosen.hidden = !(sel && mine.length); chosen.textContent = mine.map((x) => x.label + ' × ' + x.n).join(' · '); }
          const plus = it.querySelector('[data-plus]'); if (plus) plus.disabled = n >= size;
          const minus = it.querySelector('[data-minus]'); if (minus) minus.disabled = c === 0;
        });
        slots.innerHTML = '';
        for (let i = 0; i < size; i++) {
          const li = document.createElement('li');
          const e = thumbs[i];
          if (e && e.it.dataset.img) { const im = document.createElement('img'); im.src = e.it.dataset.img; im.alt = e.it.dataset.title + (e.label ? ' – ' + e.label : ''); li.title = im.alt; li.appendChild(im); li.className = 'is-full'; }
          slots.appendChild(li);
        }
        const disc = Math.round(sum * (100 - off) / 100);
        total.textContent = formatMoney(n === size ? disc : sum);
        was.hidden = !(n === size && off > 0); was.textContent = formatMoney(sum);
        if (n > size) status.textContent = S.too_many.replace('[size]', size);
        else if (n === size) status.textContent = S.ready;
        else status.textContent = S.pick.replace('[count]', size - n);
        add.disabled = n !== size;
      }
      tiers.forEach((t) => t.addEventListener('click', () => {
        tiers.forEach((x) => x.setAttribute('aria-checked', x === t ? 'true' : 'false'));
        size = parseInt(t.dataset.tier, 10); off = parseInt(t.dataset.off, 10) || 0; render();
      }));
      items.forEach((it) => {
        const p = it.querySelector('[data-plus]'); const m = it.querySelector('[data-minus]');
        const sel = it.querySelector('[data-variant]');
        if (sel) sel.addEventListener('change', () => {
          const o = sel.options[sel.selectedIndex];
          it.dataset.id = o.value; it.dataset.price = o.dataset.price;
          const pl = it.querySelector('[data-price-label]'); if (pl && o.dataset.money) pl.textContent = o.dataset.money;
          render();
        });
        if (p) p.addEventListener('click', () => {
          if (picked() >= size) return;
          const id = it.dataset.id; const e = counts.get(id) || { it, n: 0, price: parseInt(it.dataset.price, 10), label: sizeName(it) };
          e.n += 1; counts.set(id, e); render();
        });
        if (m) m.addEventListener('click', () => {
          const e = counts.get(it.dataset.id); if (!e) return;
          e.n -= 1; if (e.n <= 0) counts.delete(it.dataset.id); render();
        });
      });
      add.addEventListener('click', async () => {
        const label = S.box.replace('[size]', size);
        const payload = { items: Array.from(counts.entries()).filter(([, e]) => e.n > 0).map(([id, e]) => ({ id: parseInt(id, 10), quantity: e.n, properties: { Bundle: label } })) };
        add.disabled = true; add.classList.add('is-loading');
        try {
          const res = await fetch(routes.cart_add_url + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) });
          if (!res.ok) throw new Error('add failed');
          counts.clear(); render();
          if (window.mabel && window.mabel.cartType === 'drawer' && document.getElementById('CartDrawer')) refreshDrawer(true);
          else window.location.href = routes.cart_url;
        } catch (e) { window.location.href = routes.cart_url; }
        add.classList.remove('is-loading');
      });
      render();
    });
  }

  function safe(fn) {
    try { fn(); } catch (err) { console.error('[Mabel]', fn.name, err); }
  }

  function init() {
    [initAnnouncements, initPanels, initCart, initQty, initProducts, initVideo, initVideoReviews,
      initBeforeAfter, initFaqLinks, initHoverLists, initFilters, initRecommendations, initBackToTop, initFreeShipping,
      initSwatchCards, initSizeGuide, initLooks, initCampaigns, initQuickView, initRecentlyViewed, initCountdowns, initPopup, initSlideshows, initPress, initTabs, initSideTab, initStickyCart, initPredictive, initPickup, initCartNote, initBundleBuilder].forEach(safe);
    safe(initReveal);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', () => {
    [initAnnouncements, initProducts, initBeforeAfter, initHoverLists, initReveal, initRecommendations, initLooks, initCampaigns, initRecentlyViewed, initCountdowns, initPopup, initSlideshows, initPress, initTabs, initBundleBuilder].forEach(safe);
  });
})();
